import React from 'react'
import View from './view'

type Props = {
  breadcrumbs: BreadcrumbType[]
}

export type BreadcrumbType = {
  title: string
  url: string
}

const Breadcrumb = ({breadcrumbs}: Props) => {
  return <View breadcrumbs={breadcrumbs} />
}

export default Breadcrumb
